import React from "react";
import {Backdrop, Box, Modal} from "@mui/material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "white",
  p: 4,
  textAlign: "center",
  borderRadius: "16px",
  width: {xs: "90%", md: "inherit"},
};

export default function ModalForm({open, customStyle, children}: any) {
  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{
        overflowY: "auto",
      }}
      slots={{backdrop: Backdrop}}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            backdropFilter: "blur(10px)",
            WebkitBackdropFilter: "blur(10px)",
          },
        },
      }}
    >
      <Box sx={{...style, ...customStyle}}>{children}</Box>
    </Modal>
  );
}
